<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">题目管理</h3> -->
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="题目名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="题目类型">
          <el-select v-model="formInline.type" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.questionTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目分类">
          <el-select v-model="formInline.scope" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目来源">
          <el-select v-model="formInline.source" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.questionSources" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(clearParams)">创建题目</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="题目名称" min-width="320">
        </custom-table-column>
        <custom-table-column prop="type" label="题目类型" min-width="100">
        </custom-table-column>
        <custom-table-column prop="scope" label="题目分类" min-width="100">
        </custom-table-column>
        <custom-table-column prop="source" label="题目来源" min-width="100">
        </custom-table-column>
        <custom-table-column prop="difficulty" label="题目难度" min-width="100">
        </custom-table-column>
        <custom-table-column prop="use_count" label="使用次数" width="100">
        </custom-table-column>
        <custom-table-column prop="" label="组织结构" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="answers" label="答案" width="160">
          <template slot-scope="scope" v-if="scope.row.answers_array && scope.row.answers_array.length">
            <span>{{ scope.row.answers_array.join(",") }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="options" label="选项" min-width="200">
          <template slot-scope="scope" v-if="scope.row.options_array && scope.row.options_array != 'null'">
            <p v-for="item in scope.row.options_array" :key="item.value">{{ item.value }}. {{ item.label }}</p>
          </template>
        </custom-table-column>
        <custom-table-column label="题目配图" min-width="160">
          <template slot-scope="scope" v-if="scope.row.pic">
            <el-image v-for="(item, index) in scope.row.pic.split(',')" :key="index" :src="item"
              :preview-src-list="scope.row.pic.split(',')" style=" width:60px;margin-right: 4px;">
            </el-image>
          </template>
        </custom-table-column>
        <custom-table-column prop="answer_explain" label="答案说明" min-width="220">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建日期" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row)" type="text" size="small">详情</el-button>
            <template v-if="scope.row.source != '系统预置'">
              <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
                size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </template>
        </custom-table-column>
      </custom-table>

      <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px"
        append-to-body>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="type == 'view'" label-width="120px"
          class="demo-ruleForm">
          <el-form-item label="题目名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入" style="width:552px;"></el-input>
          </el-form-item>
          <el-form-item label="题目类型" prop="type">
            <el-select v-model="ruleForm.type" clearable style="width:216px;" placeholder="请选择"
              @change="handleTypeChange">
              <el-option v-for="item in $store.state.questionTypes" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题目分类" prop="scope">
            <el-select v-model="ruleForm.scope" clearable placeholder="请选择" style="width:216px;">
              <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题目难度" prop="difficulty">
            <el-select v-model="ruleForm.difficulty" clearable placeholder="请选择" style="width:216px;">
              <el-option v-for="item in $store.state.difficulty" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.type == '单选' || ruleForm.type == '多选' || isPd" label="题目选项" prop="options"
            style="width:100%" :rules="[{ required: true, message: '请选择' }]">
            <el-button class="button-new-tag" v-if="!isPd" size="small" @click="showInput(false)" style="margin-right: 8px;">+
              添加选项</el-button>
            <el-tag v-for="(tag, idx) in dynamicTags" @click="showInput(tag)" :key="tag.value + idx" :closable="!isPd"
              @close="handleClose(tag)">
              {{ tag.value }}. {{ tag.label }}
            </el-tag>
          </el-form-item>
          <el-form-item label="设置答案" prop="answers" v-if="ruleForm.type == '单选' || ruleForm.type == '多选' || isPd">
            <el-select v-model="answersMultiple" :multiple-limit="ruleForm.type != '多选' ? 1 : 0" multiple clearable
              style="width:216px;" placeholder="请选择">
              <el-option v-for="item in dynamicTags" :key="item.value" :label="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属组织结构" prop="structure_1">
            <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
              @clear="handeleClear" clearable></el-input>
            <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
              @handleOrganQuery="handleOrganQueryNew({ limit: false, major: 'structure_2' })">
            </OrganDialog>
          </el-form-item>
          <el-form-item label="题目配图" prop="pic" style="width:100%">
            <div style="width:552px;">
              <Uploadd ref="uploadd" fileFieldNameIn="pic" :isMultiple="true" btnTitle="点击上传图片"
                @setFileList="setFileListMultiple" uploadType="image" @delFile="delUpFile"></Uploadd>
            </div>
          </el-form-item>
          <el-form-item label="答案说明" prop="answer_explain">
            <el-input type="textarea" v-model="ruleForm.answer_explain" :rows="5" placeholder="请输入"
              style="width:552px;"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;" v-if="type != 'view'">
            <el-button type="primary" v-if="type == 'add'"
              @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
            <el-button type="primary" v-if="type == 'edit'"
              @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
            <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
        <el-dialog :close-on-click-modal="false" title="添加选项" :visible.sync="centerInnerDialogVisible" width="546px"
          append-to-body>
          <el-form :model="ruleFormInner" :rules="rulesInner" ref="ruleFormInner" label-width="100px"
            class="demo-ruleForm">
            <el-form-item label="选项值" prop="value">
              <el-select v-model="ruleFormInner.value" filterable clearable placeholder="请选择" style="width:216px;">
                <el-option v-for="item in $store.state.engCods" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选项内容" prop="label">
              <el-input type="textarea" v-model="ruleFormInner.label" :rows="5" placeholder="请输入"
                style="width:362px;"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
              <el-button type="primary" @click="submitFormByFun('ruleFormInner', setOptionVal)">确认</el-button>
              <el-button @click="resetForm('ruleFormInner')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-dialog>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px" append-to-body>
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'equipmentInto',
  // 作为子组件被题库管理引用时,传入题库 id,题目归属该题库
  props: {
    collectionId: { type: [String, Number], default: '' },
  },
  mixins: [mixinList, mixinOrgan, mixinValidate, mixinUpload],
  data() {
    return {
      formInline: {
        name: '',
        type: '',
        scope: '',
        source: '',
      },
      dynamicTags: [],
      answersMultiple: [],
      inputVisible: false,
      inputValue: '',
      centerInnerDialogVisible: false,
      ruleFormInner: { value: '', label: '' },
      ruleForm: {
        name: '',
        type: '单选',
        scope: '',
        difficulty: '',
        structure_1: "",
        structure_2: "",
        pic: '',
        answers: '',
        options: '',
        answer_explain: ''
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        // structure_1: [{ required: true, message: '请选择' }],
        type: [{ required: true, message: '请选择', trigger: 'change' }],
        answers: [{ required: true, message: '请选择', trigger: 'change' }],
        scope: [{ required: true, message: '请选择', trigger: 'change' }],
        difficulty: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      rulesInner: {
        label: [{ required: true, message: '请输入', trigger: 'blur' }],
        value: [{ required: true, message: '请选择', trigger: 'change' }],
      }
    };
  },
  computed: {
    isPd(){
      return this.ruleForm.type == '判断'
    }
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('getDangerCategorys');
  },
  watch: {
    dynamicTags(val) {
      this.ruleForm.options = val.length ? JSON.stringify(val) : ''
    },
    answersMultiple(val) {
      this.ruleForm.answers = val.length ? JSON.stringify(val) : ''
    },
  },
  methods: {
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new/question/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    // 查看详情:复用编辑回填,表单只读展示
    detailMethod(row) {
      this.handleEditNew(row, ['id'], () => this.handleEditInit(row))
      this.type = 'view'
      this.title = '详情'
    },
    handleEditInit(row) {
      if (row.options_array && row.options_array != "null") {
        this.dynamicTags = row.options_array
      } else {
        this.dynamicTags = []
      }
      if (row.answers_array && row.answers_array.length) {
        this.answersMultiple = row.answers_array
      } else {
        this.answersMultiple = []
      }
      this.ruleFormInner = { value: '', label: '' }
      this.handleEditCallBackSetStruc({ major: 'structure_2', row })
      this.handleEditCallBackSetFile({ fileField: "pic", row })
    },
    clearParams() {
      this.$nextTick(() => {
        this.$refs.uploadd.setRefFileList("")
      })
      this.dynamicTags = []
      this.answersMultiple = []
      this.ruleFormInner = { value: '', label: '' }
    },
    handleTypeChange(val) {
      if (val == '简答题') {
        this.dynamicTags = []
      }
      if(val == '判断') {
        this.dynamicTags = [
          { value: 'A', label: '正确' },
          { value: 'B', label: '错误' }
        ]
      }
      this.answersMultiple = []
    },
    setOptionVal() {
      this.centerInnerDialogVisible = false
      let flag = false
      for (let i in this.dynamicTags) {
        if (this.dynamicTags[i].value == this.ruleFormInner.value) {
          this.dynamicTags[i].label = this.ruleFormInner.label
          flag = true
        }
      }
      if (!flag) this.dynamicTags.push(this.ruleFormInner)
      this.ruleFormInner = { value: '', label: '' }
    },
    handleClose(tag) {
      this.dynamicTags = this.dynamicTags.filter(item => item.value !== tag.value);
    },
    showInput(tag) {
      if (tag) {
        this.ruleFormInner = tag
      } else {
        this.ruleFormInner.value = this.$store.state.engCods[this.dynamicTags.length]
      }
      this.centerInnerDialogVisible = true
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // 题目归属题库:由父组件 prop 传入(不在此处选择)
      if (this.collectionId) params.collection_id = this.collectionId;
      let res = await this.$api.instance.interfaceServer('api/new/question/insert', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // 题目归属题库:由父组件 prop 传入(不在此处选择)
      if (this.collectionId) params.collection_id = this.collectionId;
      let res = await this.$api.instance.interfaceServer(`api/new/question/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      // 作为子组件时按题库过滤题目
      if (this.collectionId) params.collection_id = this.collectionId;
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new/question/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-tag {
  cursor: pointer;
}

@media screen and (max-width: 1000px) {
  .content {
    margin-top: 0;
  }
}

@media screen and (min-width: 1000px) {
  .content {
    margin: 0;
    padding-top: 0;
  }
}
</style>
